import { Component, Input, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { BaseTemplate } from "../../../../../../shared/baseTemplate";
import { ViewProductInfoHandlerService } from "../../../../services/view-product-info-handler.service";
import { AuthService } from "../../../../../../shared/services/auth.service";
import { GetBusinessProfileService } from "../../../../../../shared/services/get-business-profile.service";
import { CurrencyExchangeService } from "../../../../../../shared/services/currency-exchange.service";
import { GetCalculatesParamsService } from "../../../../services/get-calculates-params.service";
import { CongratulationComponent } from "../../../../../../shared/components/congratulation/congratulation.component";
import { Meta, Title } from "@angular/platform-browser";

@Component({
  selector: 'app-quick-payment',
  templateUrl: './quick-payment.component.html',
  styleUrls: ['./quick-payment.component.scss']
})
export class QuickPaymentComponent extends BaseTemplate implements OnInit {
  QRData: string = window.location.href;
  QRWidth: number = 240;
  @Input() productObject: any;
  businessObject: any;
  sharedLink: string = window.location.href;
  payable:boolean = false;

  constructor(
    vpihs: ViewProductInfoHandlerService,
    public Dialog: MatDialog,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    auth: AuthService,
    gbps: GetBusinessProfileService,
    public exchangeService: CurrencyExchangeService,
    public getCalculatesParamsService: GetCalculatesParamsService,
    private titleService: Title,
    private metaService: Meta
  ) {
    super(vpihs, gbps, auth, exchangeService, getCalculatesParamsService);
  }

  async openShareButtonsDialog() {
    const dialogRef = this.Dialog.open(CongratulationComponent, {
      panelClass: "responsive-dialog",
      data: {
        url: window.location.href,
        name: "Quick Payment Invitation",
        type: "Quick Payment",
        showCongratulation: false,
        showButton: false
      }
    });
  }

  async ngOnInit() {
    this.businessObject = this.productObject.Business;
    this.getCalculatesParamsService.setQuantity(1);
    await this.canPay();
    await this.getCalculatesParamsService.calculateInfos();
    await this.initCurrencies();
    this.commitChanges();
  }

  proceedToPayment() {
    this.vpihs.viewInfoObject = {
      product: this.productObject,
    }
    this.router.navigate(["buyerinfo"], { relativeTo: this.activatedRoute });
  }

  calculateSubTotalAmount() {
    const currency: any = this.getProductValueByFieldName("Currency");
    this.total = (<any>this.getProductValueByFieldName("Amount")) /
      this.getExchangeRateToEGP(currency);

    return (this.vpihs.subTotal =
      (<any>this.getProductValueByFieldName("Amount")) /
      this.getExchangeRateToEGP(currency));
  }

  getProductValueByFieldName(type: any) {
    if (type === 'Currency') {
      return this.productObject.QuickPaymentExtraInfos[0].currency;
    } else if (type === "Amount") {
      return +this.productObject.QuickPaymentExtraInfos[0].amount;
    }
  }
  /** * @description check if type is buyer */
  async canPay() {
    const business = await this.auth.getBusiness()
    if (business) {
      this.payable =  this.businessObject.id != business.id;
    } 
    this.payable = true;
  }
}
